import styled from "styled-components";

const SettingsHeading = styled.h2`
  font-size: 20px;
  margin-bottom: 2rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.text};
`;

export default SettingsHeading;
